import React from 'react';
import { Box, Button } from '@mui/material';
import { color, radius, control } from './tokens';

/**
 * Page quick-actions. No hidden actions behind menus.
 * actions: [{ label, icon?, onClick, variant? 'primary'|'default', disabled? }]
 */
export default function ActionToolbar({ actions = [] }) {
  if (!actions.length) return null;
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {actions.map((a) => {
        const primary = a.variant === 'primary';
        return (
          <Button
            key={a.label}
            onClick={a.onClick}
            disabled={a.disabled}
            startIcon={a.icon}
            variant={primary ? 'contained' : 'outlined'}
            disableElevation
            sx={{
              height: control.height,
              borderRadius: `${radius.md}px`,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 13,
              whiteSpace: 'nowrap',
              ...(primary
                ? { bgcolor: color.accent, '&:hover': { bgcolor: color.accentHover } }
                : {
                    color: color.text,
                    borderColor: color.border,
                    bgcolor: color.surface,
                    '&:hover': { borderColor: color.borderStrong, bgcolor: color.surfaceAlt },
                  }),
            }}>
            {a.label}
          </Button>
        );
      })}
    </Box>
  );
}